var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-block"},[_c('home-block-title',{attrs:{"title":"学院视频","linkText":"最新动态 前沿讯息","link":{
      path: '/commonMore',
      query: {
        commonMoreName: '学院视频',
        showType: 'video',
        activeMenu: '学院视频'
      }
    }}}),_c('div',{staticClass:"list"},[_c('swiper',{ref:"mySwiper",staticClass:"swiper-video",attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.list),function(item,index){return _c('swiper-slide',{key:index},[_c('iframe',{staticStyle:{"width":"100%","height":"450px"},attrs:{"src":item.videoUrl,"frameborder":"0","allowfullscreen":""}}),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(item.videoName)+" ")])])}),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination","id":"swiper-pagination-video"},slot:"pagination"})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }